/* eslint-disable no-shadow */
import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faTimes, faCheck } from "@fortawesome/free-solid-svg-icons";
import { selectWidgetTimescale } from "../../../actions/employerAnalyticsActions";
import timescaleOptionsTypes from "../types/timescaleOptionsTypes";
import {
  Dropdown,
  DropdownTriggerWrapper,
  DropdownTrigger,
  DropdownTriggerIconWrapper,
  DropdownTriggerInner,
  ResetFilter,
  DropdownOptions,
  Header,
  CloseButton,
  DropdownOption,
} from "../styles/timescale-dropdown-styles";

interface ITimeScaleDropDownProps {
  toggleDropdown: () => void;
  dropdownActive: boolean;
  selectTimescale: (arg: unknown) => void;
  activeTimescale: {
    id?: number;
    name?: string;
  };
  options: Array<{ id: number; name: string }>;
  selectWidgetTimescale: (arg: unknown) => void;
  type: string;
  testId?: string;
  resetFilterValue?: {
    id?: number;
    name?: string;
  };
}

export const TimeScaleDropDown: FunctionComponent<ITimeScaleDropDownProps> = ({
  toggleDropdown,
  dropdownActive,
  selectTimescale,
  activeTimescale,
  options,
  selectWidgetTimescale,
  type,
  testId,
  resetFilterValue,
}) => (
  <Dropdown selected={activeTimescale.id !== 0} data-test-id={testId}>
    <DropdownTriggerWrapper>
      <DropdownTrigger selected={activeTimescale.id !== 0}>
        <DropdownTriggerIconWrapper onClick={() => toggleDropdown()}>
          <FontAwesomeIcon icon={faFilter} />
        </DropdownTriggerIconWrapper>
        <DropdownTriggerInner
          selected={activeTimescale.id !== 0}
          onClick={() => toggleDropdown()}
        >
          {activeTimescale.name ? activeTimescale.name : "All Time"}
        </DropdownTriggerInner>
      </DropdownTrigger>
      {activeTimescale.id !== 0 && (
        <ResetFilter
          onClick={() => {
            selectTimescale(resetFilterValue || { id: 0, name: "All Time" });
            selectWidgetTimescale({ type, timescale: 0 });
            if (activeTimescale.id !== 0 && dropdownActive) {
              toggleDropdown();
            }
          }}
        >
          <FontAwesomeIcon icon={faTimes} />
        </ResetFilter>
      )}
    </DropdownTriggerWrapper>
    <DropdownOptions
      active={dropdownActive}
      data-test-id="timescale-dropdown-options"
    >
      <Header>Timescale</Header>
      <CloseButton onClick={() => toggleDropdown()}>
        <FontAwesomeIcon icon={faTimes} />
      </CloseButton>
      {options.map((option) => (
        <DropdownOption
          key={option.id}
          onClick={() => {
            selectTimescale(option);
            selectWidgetTimescale({ type, timescale: option.id });
            toggleDropdown();
          }}
        >
          {option.name}
          {option.id === activeTimescale.id && (
            <FontAwesomeIcon icon={faCheck} />
          )}
        </DropdownOption>
      ))}
    </DropdownOptions>
  </Dropdown>
);

TimeScaleDropDown.propTypes = {
  toggleDropdown: PropTypes.func.isRequired,
  dropdownActive: PropTypes.bool.isRequired,
  selectTimescale: PropTypes.func.isRequired,
  activeTimescale: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }).isRequired,
  options: timescaleOptionsTypes.isRequired,
  selectWidgetTimescale: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  testId: PropTypes.string,
  resetFilterValue: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }),
};

TimeScaleDropDown.defaultProps = {
  testId: null,
  resetFilterValue: null,
};

export default connect(null, { selectWidgetTimescale })(TimeScaleDropDown);
